<template>
  <div class="view-container">
  <PageHeader title="تعاریف" infoTitle="راهنمای تعاریف" :infoLearnUrl="infoLearnUrl">
    <template #info>
      <p style="line-height:1.9; white-space:pre-line;">
        در قسمت تعاریف امکان تعریف کالا/خدمات، پزشکان و گروه پزشکان وجود دارد. برای تعریف در هر قسمت با کلیک بر روی دکمه افزودن می‌توانید اطلاعات مد نظر خود را ثبت نمایید. برای جستجو ابتدا داخل کادر جستجو متن مورد نظر خود را وارد نموده سپس دکمه جستجو را بزنید.
        جهت مشاهده فیلم و راهنمای کامل آموزشی بر روی لینک زیر کلیک نمایید.
      </p>
    </template>
  </PageHeader>
    <!-- تب‌های تعاریف -->
    <div class="reports-tabs-container">
      <div class="reports-tabs">
          <button class="tab-button" :class="{ active: activeTab === 'service-definition' }"
            @click="activeTab = 'service-definition'">
            تعریف کالا/خدمات
          </button>
          <button class="tab-button" :class="{ active: activeTab === 'doctors-info' }"
            @click="activeTab = 'doctors-info'">
            اطلاعات پزشکان
          </button>
          <button class="tab-button" :class="{ active: activeTab === 'doctor-groups-definition' }"
            @click="activeTab = 'doctor-groups-definition'">
            تعریف گروه پزشکان
          </button>
        </div>
    </div>

    <!-- سرویس/کالا - شامل لیست و مودال‌های مربوطه -->
    <div v-if="activeTab === 'service-definition'" class="tab-content">
      <ClinicServices />
    </div>

    <!-- Duplicate doctors-info block removed; there's already one earlier -->

    <!-- محتوای تب تعریف گروه پزشکان -->
    <div v-if="activeTab === 'doctor-groups-definition'" class="tab-content">
      <div class="doctor-groups-container">
  <div class="sub-header">
    <h2 class="page-title">لیست گروه پزشکان</h2>
    <div></div>
    <button class="add" @click="openDoctorGroupModal">جدید</button>
      </div>
  <hr class="divider-line" />

        <!-- دکمه‌های عملیات و فیلد جستجو -->
        <div class="actions-section">
          <!-- فیلد جستجو مشابه تب پزشکان -->
          <div class="search">
            <BaseButton title="جستجو" variant="primary" @click.stop.prevent="applyDoctorGroupsSearch" />
            <input id="doctor-groups-search" type="text" v-model="doctorGroupsSearchQuery" placeholder="جستجو..." />
          </div>

          <div class="actions-buttons">
            <!-- placeholder for additional actions if needed in future -->
          </div>
        </div>

        <!-- جدول گروه‌های پزشکان (BaseTable) -->
        <BaseTable
          :items="filteredDoctorGroupsList"
          keyField="id"
          :rowClass="(group) => ({ 'selected-row': selectedDoctorGroup && selectedDoctorGroup.id === group.id })"
          :emptyText="'هیچ گروه پزشکی ثبت نشده است. برای شروع، روی دکمه «جدید» کلیک کنید.'"
          :emptyColspan="7"
          @row-click="(group) => selectDoctorGroup(group)"
        >
          <template #head>
            <tr>
              <th>ردیف</th>
              <th>کد گروه</th>
              <th>نام گروه</th>
              <th>توضیحات</th>
              <th>تعداد پزشکان</th>
              <th>وضعیت</th>
              <th>عملیات</th>
            </tr>
          </template>

          <template #row="{ item: group, index }">
            <td :data-label="'ردیف'">{{ index + 1 }}</td>
            <td :data-label="'کد گروه'">{{ group.groupCode }}</td>
            <td :data-label="'نام گروه'">{{ group.groupName }}</td>
            <td :data-label="'توضیحات'">{{ group.description }}</td>
            <td :data-label="'تعداد پزشکان'">{{ group.doctorCount }}</td>
            <td :data-label="'وضعیت'">{{ group.isActive ? 'فعال' : 'غیرفعال' }}</td>
            <td class="actions-cell" data-label="عملیات">
              <button class="action-btn edit" @click.stop.prevent="handleEditDoctorGroup(group)" aria-label="ویرایش">
                <img src="/img/edit.svg" alt="ویرایش" />
              </button>
              <button class="action-btn delete" @click.stop.prevent="deleteDoctorGroup(group.id)" aria-label="حذف">
                <img src="/img/trash.svg" alt="حذف" />
              </button>
            </td>
          </template>
        </BaseTable>
        
        <!-- embedded doctors list removed as requested (duplicate) -->
      </div>
    </div>

    <!-- محتوای تب اطلاعات پزشکان: نمایش کامل صفحه پزشکان (از فایل clinic-doctors.vue) -->
    <div v-if="activeTab === 'doctors-info'" class="tab-content">
      <div class="embedded-doctors">
        <ClinicDoctors />
      </div>
    </div>

    <!-- سرویس‌ها توسط کامپوننت ClinicServices مدیریت می‌شوند -->

    <!-- مودال فرم گروه پزشکان -->
  <div v-if="isDoctorGroupModalOpen" class="modal-overlay">
      <div class="modal-content">
        <div class="sub-header">
          <ModalHeader>
            <template #default>
                <h2 class="page-title">{{ doctorGroupFormMode === 'add' ? 'افزودن گروه پزشکان جدید' : 'ویرایش گروه پزشکان' }}</h2>
              </template>
          </ModalHeader>
          <div class="form-actions">
            <BaseButton title="ثبت اطلاعات" variant="primary" type="submit" form="doctor-group-form" style="margin-left: 10px;" />
            <BaseButton title="انصراف" variant="cancel" @click="closeDoctorGroupModal" />
          </div>
        </div>
  <hr class="divider-line" />
        <form @submit.prevent="handleDoctorGroupSubmit" class="doctor-group-form-container" id="doctor-group-form">
          <div class="top-section">
            <div class="top-form-fields">
              <div class="form-group">
                <label for="group-code">
                  کد گروه <span class="required">*</span>
                </label>
                <input id="group-code" type="text" v-model="doctorGroupForm.groupCode" required />
              </div>
              <div class="form-group">
                <label for="group-name">
                  نام گروه <span class="required">*</span>
                </label>
                <input id="group-name" type="text" v-model="doctorGroupForm.groupName" required />
              </div>
              <div class="form-group">
                <label for="group-status">
                  وضعیت <span class="required">*</span>
                </label>
                <select id="group-status" v-model="doctorGroupForm.isActive" required>
                  <option value="true">فعال</option>
                  <option value="false">غیرفعال</option>
                </select>
              </div>
            </div>

            <div class="bottom-form-fields">
              <div class="form-group full-width">
                <label for="group-description">توضیحات</label>
                <textarea id="group-description" v-model="doctorGroupForm.description" rows="3"
                  placeholder="توضیحات مربوط به گروه پزشکان..."></textarea>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- مودال فرم اطلاعات پزشکان -->
  <div v-if="isDoctorModalOpen" class="modal-overlay">
      <div class="modal-content">
        <div class="sub-header">
          <ModalHeader>
            <template #default>
              <h2 class="page-title">{{ doctorFormMode === 'add' ? 'افزودن پزشک جدید' : 'ویرایش اطلاعات پزشک' }}</h2>
            </template>
            <template #actions>
              <button class="modal-close-btn">
                <font-awesome-icon :icon="['fas', 'arrow-right']" />
              </button>
            </template>
          </ModalHeader>
          <div class="form-actions">
            <BaseButton title="ثبت اطلاعات" variant="primary" type="submit" form="doctor-form" />
          </div>
        </div>
  <hr class="divider-line" />
        <form @submit.prevent="handleDoctorSubmit" class="doctor-form-container" id="doctor-form">
          <div class="top-section">
            <div class="top-form-fields">
              <div class="form-group">
                <label for="doctor-name">
                  نام و نام خانوادگی <span class="required">*</span>
                </label>
                <input id="doctor-name" type="text" v-model="doctorForm.fDname" required />
              </div>
              <div class="form-group">
                <label for="doctor-nezamno">
                  شماره نظام پزشکی <span class="required">*</span>
                </label>
                <input id="doctor-nezamno" type="text" v-model="doctorForm.fDnezamno" required />
              </div>
              <div class="form-group">
                <label for="doctor-percent">
                  درصد <span class="required">*</span>
                </label>
                <input id="doctor-percent" type="number" v-model="doctorForm.fDpercent" required />
              </div>
            </div>

            <div class="bottom-form-fields">
              <div class="form-group">
                <label for="doctor-takhasos">تخصص</label>
                <input id="doctor-takhasos" type="text" v-model="doctorForm.fDtakhasos" />
              </div>
              <div class="form-group">
                <label for="doctor-mobile">تلفن همراه</label>
                <input id="doctor-mobile" type="tel" v-model="doctorForm.fDmobile" />
              </div>
              <div class="form-group">
                <label for="doctor-tele">تلفن ثابت</label>
                <input id="doctor-tele" type="tel" v-model="doctorForm.fDtele" />
              </div>
            </div>

            <div class="form-group full-width">
              <label for="doctor-addr">آدرس</label>
              <textarea id="doctor-addr" v-model="doctorForm.fDaddr" rows="3" placeholder="آدرس پزشک..."></textarea>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- Info handled by PageHeader -->
  </div>
</template>

<script setup>
import PageHeader from '@/components/PageHeader.vue';
import { ref, reactive, computed } from "vue";
import { storeToRefs } from "pinia";
import { useDoctorsStore } from "@/stores/clinic/doctors.js";
import ModalHeader from '@/components/ModalHeader.vue'
import BaseButton from '@/components/UiCompunents/BaseButton.vue';
import BaseTable from '@/components/UiCompunents/BaseTable.vue';
import { useConfirm } from '@/stores/composables.js'
import ClinicDoctors from './clinic-doctors.vue'
import ClinicServices from "./clinic-services.vue";

// --- State ---
const activeTab = ref('service-definition');

// Doctor Groups State
const isDoctorGroupModalOpen = ref(false);
const doctorGroupsSearchQuery = ref("");
const doctorGroupFormMode = ref("add");
const editingDoctorGroupId = ref(null);
const selectedDoctorGroup = ref(null);
const doctorGroupsList = ref([
  // Sample data - in real app this would come from API
  {
    id: 1,
    groupCode: "GP001",
    groupName: "گروه قلب و عروق",
    description: "متخصصین قلب و عروق",
    doctorCount: 5,
    isActive: true
  },
  {
    id: 2,
    groupCode: "GP002",
    groupName: "گروه اطفال",
    description: "متخصصین اطفال",
    doctorCount: 3,
    isActive: true
  }
]);

// Doctors State
const isDoctorModalOpen = ref(false);
const doctorsSearchQuery = ref("");
const doctorFormMode = ref("add");
const editingDoctorId = ref(null);
const selectedDoctor = ref(null);

// --- Store Setup ---

const doctorsStore = useDoctorsStore();
const { doctorsList } = storeToRefs(doctorsStore);
const { addDoctor, updateDoctor, deleteDoctor: removeDoctor } = doctorsStore;

// service state is managed in ClinicServices component

// Doctor Groups Form State
const initialDoctorGroupFormState = {
  groupCode: "",
  groupName: "",
  description: "",
  isActive: "true",
};

let doctorGroupForm = reactive({ ...initialDoctorGroupFormState });

// Doctor Form State
const initialDoctorFormState = {
  fDname: "",
  fDnezamno: "",
  fDtakhasos: "",
  fDmobile: "",
  fDtele: "",
  fDaddr: "",
  fDpercent: 0,
  fDauto: 0,
  isActive: true
};

let doctorForm = reactive({ ...initialDoctorFormState });

// services list is handled inside ClinicServices
const filteredDoctorGroupsList = computed(() => {
  if (!doctorGroupsSearchQuery.value.trim()) return doctorGroupsList.value;

  const query = doctorGroupsSearchQuery.value.toLowerCase().trim();

  return doctorGroupsList.value.filter((group) => {
    return (
      (group.groupCode &&
        group.groupCode.toLowerCase().includes(query)) ||
      (group.groupName &&
        group.groupName.toLowerCase().includes(query)) ||
      (group.description &&
        group.description.toLowerCase().includes(query))
    );
  });
});

const filteredDoctorsList = computed(() => {
  if (!doctorsSearchQuery.value.trim()) return doctorsList.value;

  const query = doctorsSearchQuery.value.toLowerCase().trim();

  return doctorsList.value.filter((doctor) => {
    return (
      (doctor.fDname &&
        doctor.fDname.toLowerCase().includes(query)) ||
      (doctor.fDnezamno &&
        doctor.fDnezamno.toLowerCase().includes(query)) ||
      (doctor.fDtakhasos &&
        doctor.fDtakhasos.toLowerCase().includes(query)) ||
      (doctor.fDmobile &&
        doctor.fDmobile.toLowerCase().includes(query)) ||
      (doctor.fDtele &&
        doctor.fDtele.toLowerCase().includes(query))
    );
  });
});

// Info modal state & link
// Info modal is now handled by PageHeader
const infoLearnUrl = 'https://www.sinapardazesh.ir/matab-learning-web/'

// openInfoModal handled by PageHeader component

// --- Methods ---
// services are handled in ClinicServices component (open/close/submit/delete present there)

// --- Doctor Groups Methods ---
function openDoctorGroupModal() {
  doctorGroupFormMode.value = "add";
  editingDoctorGroupId.value = null;
  Object.assign(doctorGroupForm, initialDoctorGroupFormState);
  isDoctorGroupModalOpen.value = true;
}

function closeDoctorGroupModal() {
  isDoctorGroupModalOpen.value = false;
  Object.assign(doctorGroupForm, initialDoctorGroupFormState);
}

function selectDoctorGroup(group) {
  selectedDoctorGroup.value = group;
}

async function deleteDoctorGroup(groupId) {
  const { confirm } = useConfirm();
  const confirmed = await confirm("آیا از حذف این گروه پزشکان اطمینان دارید؟")
  if (!confirmed) return;
  const idToDelete = groupId || (selectedDoctorGroup.value && selectedDoctorGroup.value.id);
  if (!idToDelete) return;
  const index = doctorGroupsList.value.findIndex(g => g.id === idToDelete);
  if (index > -1) {
    doctorGroupsList.value.splice(index, 1);
  }
  if (selectedDoctorGroup.value && selectedDoctorGroup.value.id === idToDelete) {
    selectedDoctorGroup.value = null;
  }
  alert("گروه پزشکان با موفقیت حذف شد.");
}

function handleEditDoctorGroup(group) {
  doctorGroupFormMode.value = 'edit';
  editingDoctorGroupId.value = group.id;
  Object.assign(doctorGroupForm, {
    groupCode: group.groupCode,
    groupName: group.groupName,
    description: group.description,
    isActive: group.isActive ? 'true' : 'false'
  });
  isDoctorGroupModalOpen.value = true;
}

function handleDoctorGroupSubmit() {
  if (doctorGroupFormMode.value === "add") {
    const newGroup = {
      id: Date.now(), // Simple ID generation
      groupCode: doctorGroupForm.groupCode,
      groupName: doctorGroupForm.groupName,
      description: doctorGroupForm.description,
      isActive: doctorGroupForm.isActive === "true",
      doctorCount: 0
    };
    doctorGroupsList.value.push(newGroup);
  } else {
    const index = doctorGroupsList.value.findIndex(g => g.id === editingDoctorGroupId.value);
    if (index > -1) {
      doctorGroupsList.value[index] = {
        ...doctorGroupsList.value[index],
        groupCode: doctorGroupForm.groupCode,
        groupName: doctorGroupForm.groupName,
        description: doctorGroupForm.description,
        isActive: doctorGroupForm.isActive === "true"
      };
    }
  }

  closeDoctorGroupModal();
  alert("اطلاعات گروه پزشکان با موفقیت ثبت شد.");
}

function exportDoctorGroupsToExcel() {
  // TODO: پیاده‌سازی exportDoctorGroupsToExcel
  alert("قابلیت خروجی اکسل در حال توسعه است.");
}

function applyDoctorGroupsSearch() {
  // currently the search is reactive via computed; this function kept for parity with doctors tab
  // we can add debounced server-side fetch here if needed
}

function applyDoctorsSearch() {
  // placeholder for the embedded doctors search button - ClinicDoctors handles its own local search.
}

// --- Doctor Methods ---
function openDoctorModal() {
  doctorFormMode.value = "add";
  editingDoctorId.value = null;
  Object.assign(doctorForm, initialDoctorFormState);
  isDoctorModalOpen.value = true;
}

function closeDoctorModal() {
  isDoctorModalOpen.value = false;
  Object.assign(doctorForm, initialDoctorFormState);
}

function selectDoctor(doctor) {
  selectedDoctor.value = doctor;
}

async function deleteDoctor() {
  if (!selectedDoctor.value) return;
  const { confirm } = useConfirm();
  const confirmed = await confirm("آیا از حذف این پزشک اطمینان دارید؟")
  if (!confirmed) return;
  removeDoctor(selectedDoctor.value.fDauto);
  selectedDoctor.value = null;
  alert("پزشک با موفقیت حذف شد.");
}

function handleDoctorSubmit() {
  if (doctorFormMode.value === "add") {
    addDoctor({ ...doctorForm });
  } else {
    updateDoctor({ ...doctorForm });
  }

  closeDoctorModal();
  alert("اطلاعات پزشک با موفقیت ثبت شد.");
}

function exportDoctorsToExcel() {
  // TODO: پیاده‌سازی exportDoctorsToExcel
  alert("قابلیت خروجی اکسل در حال توسعه است.");
}
</script>

<style scoped>
.view-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
}

/* تب‌ها */
.reports-tabs-container {
  margin-bottom: 20px;
  border-bottom: 2px solid var(--text-color-secondary);
}

.reports-tabs {
  display: flex;
  gap: 0;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  direction: rtl;
  justify-content: flex-start;
}

.reports-tabs::-webkit-scrollbar {
  display: none;
}

.tab-button {
  padding: 15px 25px;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-color-secondary);
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  min-width: fit-content;
  flex-shrink: 0;
}

.tab-button:hover {
  color: var(--text-color-primary);
  background-color: var(--background-color-secondary);
}

.tab-button.active {
  color: var(--text-color-primary);
  border-bottom-color: var(--text-color-primary);
  background-color: var(--background-color-secondary);
}

.tab-content {
  background: var(--background-color);
  border: 1px solid var(--border-color);
  border-radius: 8px;
}

.divider-line {
  /* Use global centralized divider style; overrides if needed for local variant */
  width: 100%;
  padding: 0px;
  margin: 15px auto; /* keep slightly larger margin for this view */
  border: none;
  border-top: 1px solid rgba(var(--text-color-secondary-rgb), 0.3);
  background-color: transparent;
}

.sub-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: var(--text-color-secondary);
}




/* بخش دکمه‌ها و جستجو */
.actions-section {
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  flex-wrap: wrap;
  gap: 15px;
}

/* دکمه‌های عملیات */
.actions-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

/* فیلد جستجو */
.search {
  min-width: 200px;
  max-width: 300px;
}

.doctor-groups-container .actions-section { justify-content: flex-start; }
.doctor-groups-container .search { display: flex; gap: 8px; align-items: center; flex-direction: row-reverse; flex: 1 1 auto; min-width: 0; max-width: none; }
.doctor-groups-container .search input#doctor-groups-search { width: auto; flex: 1; padding: 6px; border: 1px solid var(--text-color-secondary); border-radius: 10px; text-align: start; background-color: var(--background-color); color: var(--text-color-primary); }
.doctor-groups-container .search .search-button { padding: 8px 14px; border-radius: 8px; border: none; background-color: var(--background-color-button); color: var(--background-color); cursor: pointer; }
.doctor-groups-container .actions-buttons { flex: 0 0 auto; }
.doctor-groups-container .search .search-button:hover { background-color: var(--background-color-button-hover); }

input#general-search,
input#doctor-groups-search,
input#doctors-search {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid var(--text-color-secondary);
  border-radius: 10px;
  text-align: start;
  background-color: var(--background-color);
  color: var(--text-color-primary);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

input#general-search:focus,
input#doctor-groups-search:focus,
input#doctors-search:focus {
  outline: none;
  border-color: var(--text-color-primary);
  box-shadow: 0 0 0 2px rgba(var(--background-color-button-rgb), 0.12);
}

input#general-search::placeholder,
input#doctor-groups-search::placeholder,
input#doctors-search::placeholder {
  color: var(--text-color-secondary);
  opacity: 1;
}

/* جدول */

.selected-row {
  background-color: rgba(23, 162, 184, 0.2) !important;
}

.empty-row td {
  text-align: center;
  padding: 40px;
  color: var(--text-color-secondary);
}

/* Action buttons (used in the table actions column) */
.action-btn {
  height: var(--action-btn-size, 32px);
  width: var(--action-btn-size, 32px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid rgba(var(--text-color-secondary-rgb), 0.12);
  background-color: transparent;
  cursor: pointer;
  padding: 4px;
}

.action-btn img {
  width: var(--action-icon-size, 18px);
  height: var(--action-icon-size, 18px);
}

.action-btn.edit { color: #1476f3; }
.action-btn.delete { color: #ff0f0f; }

/* فرم */
.service-form-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.top-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.top-form-fields,
.bottom-form-fields {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  margin-bottom: 5px;
  color: var(--tex-color-thirdly);
  text-align: justify;
}

.required {
  color: #ff0f0f;
  margin-right: 4px;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 8px 12px;
  border: 1px solid var(--text-color-secondary);
  border-radius: 10px;
  text-align: right;
  direction: rtl;
  width: 100%;
  background-color: var(--background-color);
  color: var(--text-color-primary);
}

/* Doctor Groups Form */
.doctor-group-form-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Doctor Form */
.doctor-form-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.full-width {
  grid-column: 1 / -1;
}

.form-group input,
.form-group select {
  height: 40px;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--text-color-primary);
}

.form-actions {
  display: flex;
  justify-content: flex-start;
}

  /* submit-button replaced by BaseButton (variant="primary") */



/* مودال */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: calc(100dvh - 65px);
  margin-top: 65px;
  background-color: rgba(var(--text-color-secondary-rgb), 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: var(--background-color);
  padding: 20px;
  border-radius: 30px;
  border: 1px solid var(--text-color-secondary);
  width: auto;
  max-height: 90vh;
  max-width: 90vw;
  overflow-y: auto;
  position: relative;
  direction: rtl;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.modal-close-btn {
  border: none;
  font-size: calc(0.3vw + 12px);
  color: var(--text-color-secondary);
  background-color: transparent;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

/* When embedding the full ClinicDoctors page here, hide its top header (we show our own) */
.embedded-doctors .header {
  display: none;
}

/* Add button style in sub-header similar to other pages */
.sub-header .add {
  display: flex;
  align-items: center;
  padding: 10px 22px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  background-color: var(--background-color-button);
  color: var(--background-color);
}

.sub-header .add:hover { background-color: var(--background-color-button-hover); }

/* Make doctor groups table layout RTL so columns appear right-to-left */
.doctor-groups-container .table-wrapper { direction: rtl; }

/* Provide padding inside doctor groups view */
.doctor-groups-container { padding: 20px; }

.doctor-groups-container .sub-header { justify-content: space-between; align-items: center; }


/* رسپانسیو */
@media (max-width: 768px) {
  .reports-tabs {
    justify-content: center;
  }

  .tab-button {
    font-size: 12px;
    padding: 10px 15px;
  }

  .top-form-fields,
  .bottom-form-fields {
    grid-template-columns: 1fr;
  }

  .actions-section {
    flex-direction: column;
    align-items: stretch;
  }

  .actions-buttons {
    justify-content: center;
    margin-bottom: 10px;
  }

  .search {
    min-width: unset;
    max-width: unset;
  }

  .btn {
    width: 100%;
  }
}
</style>
